import script from "./VInputCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./VInputCalendar.vue?vue&type=script&setup=true&lang=js"

import "./VInputCalendar.vue?vue&type=style&index=0&id=29c36c49&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29c36c49"]])

export default __exports__